export default {
    DoNotCall: {
        data: [],

    },
};